/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Number/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Number({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Phone/Fields/Number",
  isInvalid,
  onChange
  
}) {
let newProfessionalPhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'new_professional',
path: 'phone.number',
format: fromFormat.phoneNumberUS,
})
let newProfessionalPhoneNumberIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_professional',
path: 'phone.number',
validate: fromValidate.phoneNumber,
})
let newProfessionalPhoneNumberChangeData = fromData.useDataChange({ viewPath,
context: 'new_professional',
path: 'phone.number',
formatOut: fromFormat.addPrefixIfMissing,
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 flexBasis={2}
 flexGrow={2}
 data="new_professional.phone.number"
 format="/Data/format.js phoneNumberUS"
 formatOut="/Data/format.js addPrefixIfMissing"
 validate="/Data/validate.js phoneNumber"
 invalid={!newProfessionalPhoneNumberIsValidData}
 value={newProfessionalPhoneNumberValueData}
 onChange={newProfessionalPhoneNumberChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Phone Number"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="phone"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}